export const FORM_TYPE_OPTIONS = [
    { value: "functional_test", label: "Functional Test" },
    { value: "pm_checklist", label: "PM Checklist" },
    { value: "generic", label: "Generic" },
];
